import { Spacing } from '@persona-id/design-tokens';
import { components, SingleValueProps } from 'react-select';
import styled from 'styled-components';

import AvailabilityCircle from 'dashboard/components-lib/AvailabilityCircle';
import { FormAssignCaseUserOption } from 'dashboard/forms/FormAssignCase/FormAssignCase';

const NAME_TRUNCATE_LENGTH = 28;

const StyledAvailabilityCircle = styled(AvailabilityCircle)`
  display: inline-block;
  margin-left: ${Spacing[2]};
`;

const FormAssignCaseSingleValue = (props: SingleValueProps<FormAssignCaseUserOption>) => {
  const getName = () => {
    let name = props.data.label;
    if (typeof props.data.label === 'string' && props.data.label.length > NAME_TRUNCATE_LENGTH) {
      name = props.data.label.substring(0, NAME_TRUNCATE_LENGTH) + '...';
    }
    if (props.data.isCurrentUser) {
      name += ' (Assign to me)';
    }
    return name;
  };

  return (
    <components.SingleValue {...props}>
      {getName()}
      {props.data.availability && (
        <StyledAvailabilityCircle availability={props.data.availability} />
      )}
    </components.SingleValue>
  );
};

export default FormAssignCaseSingleValue;
